import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-366033a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, null, -1))
const _hoisted_3 = { class: "content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-title-4',
  props: {
    innerText: { default: '大标题' },
    maxLine: { default: 1 },
    enInnerText: { default: 'Big Title' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("p", {
          class: "text",
          style: _normalizeStyle({ '--max-line': _ctx.maxLine })
        }, _toDisplayString(_ctx.innerText), 5),
        _createElementVNode("p", {
          class: "en-text",
          style: _normalizeStyle({ '--max-line': _ctx.maxLine })
        }, _toDisplayString(_ctx.enInnerText), 5)
      ])
    ])
  ]))
}
}

})